var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSoundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9853 0.613281C11.609 0.613281 0.765625 11.4583 0.765625 24.8345C0.765625 38.2107 11.609 49.0557 24.9853 49.0557C38.3615 49.0557 49.2065 38.2123 49.2065 24.8345C49.2065 11.4567 38.3615 0.613281 24.9853 0.613281ZM24.9853 46.8293C12.8377 46.8293 2.99045 36.982 2.99045 24.8345C2.99045 12.687 12.8377 2.83811 24.9853 2.83811C37.1328 2.83811 46.9801 12.6854 46.9801 24.8329C46.9801 36.9804 37.1328 46.8277 24.9853 46.8277V46.8293Z",
    fill: "url(#paint0_linear_318_212)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0008 0C11.1931 0 0 11.1931 0 24.9992C0 38.8053 11.1931 49.9984 25.0008 49.9984C38.8085 49.9984 50 38.8053 50 24.9992C50 11.1931 38.8069 0 25.0008 0ZM25.0008 48.5997C18.6969 48.5997 12.7715 46.1439 8.31382 41.6878C3.85615 37.2301 1.40194 31.3031 1.40194 25.0008C1.40194 18.6985 3.85615 12.7715 8.31382 8.31382C12.7699 3.85454 18.6969 1.40034 25.0008 1.40034C31.3047 1.40034 37.2301 3.85454 41.6878 8.31221C46.1455 12.7699 48.5997 18.6953 48.5997 24.9992C48.5997 31.3031 46.1455 37.2285 41.6878 41.6862C37.2301 46.1422 31.3047 48.5981 25.0008 48.5981V48.5997Z",
    fill: "url(#paint1_linear_318_212)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M25.0006 49.3157C13.7113 49.3157 4.15593 41.9611 0.941406 31.8203C3.91051 42.3124 13.5573 49.9991 25.0006 49.9991C36.444 49.9991 46.0891 42.3124 49.0582 31.8203C45.8437 41.9611 36.2884 49.3157 25.0006 49.3157Z",
    fill: "url(#paint2_linear_318_212)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.16 7.83804C37.5756 3.25525 31.4818 0.730469 24.9998 0.730469C18.5178 0.730469 12.424 3.25525 7.83964 7.83964C3.25525 12.4224 0.730469 18.5178 0.730469 24.9982C0.730469 31.4786 3.25525 37.574 7.83804 42.1584C12.4224 46.7412 18.5178 49.266 24.9982 49.266C31.4786 49.266 37.574 46.7412 42.1584 42.1584C46.7412 37.5756 49.266 31.4802 49.266 24.9982C49.266 18.5162 46.7412 12.4224 42.1584 7.83804H42.16ZM41.6868 41.6852C37.2291 46.1413 31.3038 48.5971 24.9998 48.5971C18.6959 48.5971 12.7705 46.1413 8.31284 41.6852C3.85517 37.2275 1.40096 31.3006 1.40096 24.9982C1.40096 18.6959 3.85517 12.7689 8.31284 8.31123C12.7689 3.85356 18.6959 1.39936 24.9998 1.39936C31.3038 1.39936 37.2291 3.85356 41.6868 8.31123C46.1445 12.7689 48.5987 18.6943 48.5987 24.9982C48.5987 31.3022 46.1445 37.2275 41.6868 41.6852Z",
    fill: "url(#paint3_linear_318_212)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M49.0582 18.1788C46.0891 7.68663 36.4424 0 25.0006 0C13.5589 0 3.91051 7.68663 0.941406 18.1788C4.15593 8.03953 13.7113 0.753906 25.0006 0.753906C36.29 0.753906 45.8437 8.03792 49.0582 18.1788Z",
    fill: "url(#paint4_linear_318_212)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0553 8.94729C36.7661 4.65804 31.0653 2.29688 25.0003 2.29688C18.9354 2.29688 13.2346 4.65804 8.94533 8.94729C4.65609 13.2365 2.29492 18.9373 2.29492 25.0023C2.29492 31.0672 4.65769 36.768 8.94533 41.0573C13.233 45.3449 18.9354 47.7061 25.0003 47.7061C31.0653 47.7061 36.7661 45.3449 41.0553 41.0573C45.3429 36.768 47.7041 31.0672 47.7041 25.0023C47.7041 18.9373 45.3429 13.2365 41.0553 8.94729ZM25.0003 46.317C19.3075 46.317 13.9532 44.1002 9.92702 40.074C5.90084 36.0478 3.68403 30.6951 3.68403 25.0023C3.68403 19.3095 5.90084 13.9551 9.92702 9.93057C13.9532 5.90439 19.3059 3.68759 25.0003 3.68759C30.6947 3.68759 36.0474 5.90439 40.0736 9.93057C44.0998 13.9568 46.3166 19.3095 46.3166 25.0023C46.3166 30.6951 44.0998 36.0494 40.0736 40.074C36.0474 44.1002 30.6947 46.317 25.0003 46.317Z",
    fill: "url(#paint5_linear_318_212)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M41.3755 40.3116C37.0013 44.5993 31.185 46.9605 24.9997 46.9605C18.8145 46.9605 12.9998 44.5993 8.62554 40.3116C7.08725 38.8038 5.79278 37.1196 4.75977 35.3086C5.82967 37.4035 7.23482 39.3412 8.94635 41.0527C13.234 45.3404 18.9364 47.7015 25.0013 47.7015C31.0663 47.7015 36.7671 45.3404 41.0563 41.0527C42.7679 39.3412 44.1714 37.4051 45.2413 35.3086C44.2083 37.1212 42.9138 38.8038 41.3755 40.3116Z",
    fill: "url(#paint6_linear_318_212)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M45.2413 14.6898C44.1714 12.5949 42.7663 10.6572 41.0563 8.94568C36.7671 4.65804 31.0647 2.29688 25.0013 2.29688C18.938 2.29688 13.2356 4.65804 8.94635 8.94568C7.23482 10.6572 5.82967 12.5933 4.75977 14.6898C5.79278 12.8772 7.08725 11.1946 8.62554 9.68676C12.9998 5.39912 18.8145 3.03795 24.9997 3.03795C31.185 3.03795 36.9997 5.39912 41.3755 9.68676C42.9138 11.1946 44.2083 12.8788 45.2413 14.6898Z",
    fill: "url(#paint7_linear_318_212)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5419 9.46051C36.3906 5.30922 30.8711 3.02344 25.0002 3.02344C19.1294 3.02344 13.6099 5.30922 9.45856 9.46051C5.30726 13.6118 3.02148 19.1314 3.02148 25.0022C3.02148 30.873 5.30726 36.3926 9.45856 40.5439C13.6099 44.6952 19.1294 46.981 25.0002 46.981C30.8711 46.981 36.3906 44.6952 40.5419 40.5439C44.6932 36.3926 46.979 30.873 46.979 25.0022C46.979 19.1314 44.6932 13.6118 40.5419 9.46051ZM40.0736 40.0739C36.0474 44.1001 30.6946 46.3169 25.0002 46.3169C19.3059 46.3169 13.9531 44.1001 9.92694 40.0739C5.90076 36.0477 3.68396 30.695 3.68396 25.0022C3.68396 19.3094 5.90076 13.9551 9.92694 9.9305C13.9531 5.90432 19.3059 3.68752 25.0002 3.68752C30.6946 3.68752 36.0474 5.90432 40.0736 9.9305C44.0997 13.9567 46.3165 19.3094 46.3165 25.0022C46.3165 30.695 44.0997 36.0493 40.0736 40.0739Z",
    fill: "url(#paint8_linear_318_212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_212",
    x1: 52.7771,
    y1: 70.3255,
    x2: 27.4363,
    y2: 28.8463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_212",
    x1: 25.0008,
    y1: 0,
    x2: 25.0008,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_212",
    x1: 25.0006,
    y1: 31.8203,
    x2: 25.0006,
    y2: 50.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_212",
    x1: -0.000979357,
    y1: 49.2676,
    x2: 0.159426,
    y2: 0.730468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_212",
    x1: 25.0006,
    y1: 18.1804,
    x2: 25.0006,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_212",
    x1: -0.000480249,
    y1: 18.7192,
    x2: 0.159925,
    y2: 64.1268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_212",
    x1: 25.0013,
    y1: 34.0719,
    x2: 25.0013,
    y2: 48.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_212",
    x1: 25.0013,
    y1: 14.6898,
    x2: 25.0013,
    y2: 2.29688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_212",
    x1: 25.0002,
    y1: 46.981,
    x2: 25.0002,
    y2: 3.02183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSoundCircle);
export default __webpack_public_path__ + "static/media/menu-sound-circle.9acedc3c05d54a5b5dc85286765ac1ec.svg";
export { ForwardRef as ReactComponent };